module.exports = __webpack_public_path__ + "img/icon-model-to-fill.ab1286bd.svg";